<template>
    <aside class="job__information">
        <header class="job__header">
            <div class="job__titles">
                <job-title />
                <p class="job__subtitle">
                    Requested by <span class="text--highlight">{{ job.requester.display_name }}</span> <relative-time :timestamp="job.timestamp" />
                    <template v-if="isMobile">
                        | <strong>{{ job.column.name }}</strong>
                    </template>
                </p>
            </div>
            <ul class="job__labels">
                <li class="job__labels__item" :key="index" v-for="(label, index) in job.labels">
                    <span class="label" :class="{[`label--${label.color}`]: true}">{{ label.name }}</span>
                </li>
            </ul>
        </header>
        <footer class="job__footer">
            <div class="job__controls">
                <due-date />
                <status />
            </div>
            <!-- <labels />-->
             <members :users="activeMembers" position="right" />
        </footer>
    </aside>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Device from '../../mixins/deviceAware'
import Members from './Members'
import DueDate from '../Global/DatePicker'
import RelativeTime from '../Global/RelativeTime'
import Status from './ColumnDropdown'
import JobTitle from './JobTitle'

export default {
    name: 'Information',

    mixins: [Device],

    computed: {
        ...mapState('job', ['job']),
        ...mapGetters('channel', ['activeMembers'])
    },

    components: {
        Members,
        DueDate,
        Status,
        JobTitle,
        RelativeTime
    }
}
</script>
